import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../Services/api";

const PatientSelection = () => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      setLoading(true);
      const response = await api.get("/all");
      setPatients(response.data);
    } catch (error) {
      console.error("Error fetching patients:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePatientSelect = (patient) => {
    setSelectedPatient(patient);
  };

  const proceedToLabReport = () => {
    if (selectedPatient) {
      // Pass selected patient via navigation state (avoids plaintext PHI persistence)
      navigate("/create-lab-report", { state: { selectedPatient } });
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2">Loading patients...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="creat-lab-page py-2 px-2">
        <div className="allMainFeilds">
          <div className="basicDetails">
            <div className="row">
              <div className="col-12">
                <h4>Select Patient for Lab Report</h4>
                <p>Please select a patient to create a lab report for:</p>

                <div className="patient-selection-container">
                  {patients.length === 0 ? (
                    <div className="alert alert-warning">
                      No patients found. Please add patients first.
                    </div>
                  ) : (
                    <div className="row">
                      {patients.map((patient, index) => (
                        <div
                          key={patient.id || index}
                          className="col-md-6 col-lg-4 mb-3"
                        >
                          <div
                            className={`card patient-card ${selectedPatient?.id === patient.id ? "selected" : ""}`}
                            onClick={() => handlePatientSelect(patient)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="card-body">
                              <h5 className="card-title">
                                {patient.name ||
                                  patient.firstName + " " + patient.lastName}
                              </h5>
                              <p className="card-text">
                                <strong>ABHA:</strong>{" "}
                                {patient.abhaNumber || "N/A"}
                                {(patient.abhaAddress ||
                                  patient.ABHAAddress) && (
                                  <span
                                    style={{ marginLeft: "6px", color: "#555" }}
                                  >
                                    ·{" "}
                                    {patient.abhaAddress || patient.ABHAAddress}
                                  </span>
                                )}
                                <br />
                                <strong>Gender:</strong>{" "}
                                {patient.gender || "N/A"}
                                <br />
                                <strong>Age:</strong>{" "}
                                {patient.age || patient.yearOfBirth
                                  ? new Date().getFullYear() -
                                    patient.yearOfBirth
                                  : "N/A"}
                                <br />
                                {(patient.dob || patient.dateOfBirth) && (
                                  <>
                                    <strong>DOB:</strong>{" "}
                                    {
                                      (
                                        patient.dob || patient.dateOfBirth
                                      ).split("T")[0]
                                    }
                                    <br />
                                  </>
                                )}
                                <strong>Phone:</strong>{" "}
                                {patient.phone || patient.mobile || "N/A"}
                              </p>
                              {selectedPatient?.id === patient.id && (
                                <div className="badge badge-primary">
                                  Selected
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="basicDetailsAction">
            <button
              className="customeBtn btnEmpty me-2"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              className="customeBtn btnLightBlue"
              onClick={proceedToLabReport}
              disabled={!selectedPatient}
            >
              Create Lab Report
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .patient-card {
          transition: all 0.3s ease;
          border: 2px solid #e9ecef;
        }

        .patient-card:hover {
          border-color: #007bff;
          box-shadow: 0 4px 8px rgba(0, 123, 255, 0.25);
        }

        .patient-card.selected {
          border-color: #28a745;
          background-color: #f8fff9;
          box-shadow: 0 4px 8px rgba(40, 167, 69, 0.25);
        }

        .patient-selection-container {
          max-height: 600px;
          overflow-y: auto;
        }
      `}</style>
    </div>
  );
};

export default PatientSelection;
